import { FormGroup } from "../../../components/form/models/models";
import * as Yup from "yup";

export const ProviderUsersForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      fieldType: "dropdown",
      key: "authorisationLevel",
      label: "Authorisation Level",
      props: {
        options: [
          {
            label: "Authorised Representative",
            value: 0,
          },
          {
            label: "Inactive",
            value: 1,
          },
        ],
      },
    },
    {
      type: "field",
      key: "firstName",
      fieldType: "input",
      label: "First Name",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "lastName",
      fieldType: "input",
      label: "Last Name",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "userEmail",
      fieldType: "input",
      label: "Email",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "phoneNo1",
      fieldType: "input",
      label: "Phone",
      validation: Yup.string()
        .notRequired()
        .matches(
          RegExp(
            "^((04\\d{2} ?\\d{3} ?\\d{3})|(\\+614 ?\\d{4} ?\\d{4})|((\\(02\\)|\\(03\\)|\\(08\\)) ?\\d{4} ?\\d{4})|(02|03|08)\\s?\\d{4} ?\\d{4}|(\\+613 ?\\d{4} ?\\d{4})|(\\d{4}|d{4})|(\\d{4}\\s?\\d{4}))$"
          ),
          {
            message: "Please enter a valid Telephone number",
          }
        ),
    },
  ],
};
